import ContainerCodeNodeView from './ContainerCodeNodeView';
import {escapeHtml} from '../../Common/escapeHtml';

export default class ContainerMermaidNodeView extends ContainerCodeNodeView {
    constructor(node, view, getPos) {
        super('mermaid', node, view, getPos);
    }

    renderer(codeText) {
        const renderLoader = document.getElementById('render-loader');
        renderLoader && renderLoader.classList.add('active');

        import(/* webpackChunkName: "mermaid-renderer" */ "mermaid").then(module => {
            const mermaid = module.default;

            mermaid.initialize({
                startOnLoad: false
            });

            const handleError = error => {
                const errorMessage = error.message || 'Unable to render Mermaid diagram, please try again.';
                this.replaceDomInnerHTML(`<pre class="ui error"><code>${errorMessage ? escapeHtml(errorMessage) : ''}</code></pre>`);
                renderLoader && renderLoader.classList.remove('active');
            }

            mermaid.parse(codeText)
                .then(() => {
                    mermaid.render('mermaid-graph-' + this.getPos(), codeText)
                        .then(renderResult => {
                            this.replaceDomInnerHTML(this.wrapImage(renderResult.svg));
                            renderLoader && renderLoader.classList.remove('active');
                        })
                        .catch(handleError);
                }).catch(handleError);
        }).catch(() => {
            this.replaceDomInnerHTML(`<pre class="ui error"><code>Unable to load Mermaid diagram renderer, please try again.</code></pre>`);
            renderLoader && renderLoader.classList.remove('active');
        });
    }
}